import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './assets/global.css';
import router from './router'

loadFonts()

console.log('App initialization starting...');

const app = createApp(App)
app.use(vuetify)
app.use(router)

console.log('Mounting app...');
app.mount('#app')
console.log('App mounted');
